module.exports = __webpack_public_path__ + "img/ep_arrow-down-bold.5896cc9d.svg";